import Boost from './container';

export default Boost;



// WEBPACK FOOTER //
// ./src/components/Boost/index.js